import { useEffect } from 'react';

const PageMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description !== undefined) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute('content', description || '');
      }
    }
    return () => {
      document.title = 'GMB Autopilot - Google Business Profile Tools';
    };
  }, [title, description]);
  return null;
};

export default PageMeta;
